import { memo } from "react";
import { classNames } from "helpers";
import { transformDateToLocalDateString } from "helpers/common";
import Tooltip from "ui/components/Tooltip/Tooltip";
import { CALENDAR_EVENT_COLORS, DEFAULT_CALENDAR_EVENT_COLOR } from "../../consts";
import { CalendarEventProps } from "../../types";

const CalendarEvent: React.FC<CalendarEventProps> = (props) => {
  const { item, showChannels = false } = props;

  const color = CALENDAR_EVENT_COLORS[item.entityType] ?? DEFAULT_CALENDAR_EVENT_COLOR;

  return (
    // `trigger`, ne `decorate` — decorate omota karticu u span s iscrtkanim rubom i bez
    // `min-width: 0`, pa bi dugi naslov razvukao stupac i razbio mrežu.
    <Tooltip
      trigger={
        <div
          className={classNames(
            "w-full min-w-0 rounded-sm border px-2 py-1 overflow-hidden cursor-default",
            color.background,
            color.border
          )}
        >
          <div className={classNames("text-xs font-medium truncate", color.text)}>
            {item.title}
          </div>
          {showChannels && item.channels.length > 0 && (
            <div className={classNames("text-[11px] truncate mt-0.5", color.subtext)}>
              {item.channels.join(" · ")}
            </div>
          )}
        </div>
      }
      position="bottom-left"
      size="medium"
    >
      <div className="min-w-[240px]">
        <div className="font-medium mb-2">{item.title}</div>
        {item.entityDisplayName && (
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Entitet</span>
            <span className="font-medium text-right max-w-[150px] truncate">
              {item.entityDisplayName}
            </span>
          </div>
        )}
        {item.relevantDate && (
          <div className="flex justify-between text-sm mb-1">
            <span className="text-slate-300">Datum isteka</span>
            <span className="font-medium">
              {transformDateToLocalDateString(new Date(item.relevantDate))}
            </span>
          </div>
        )}
        <div className="flex justify-between text-sm mb-1">
          <span className="text-slate-300">Broj slanja</span>
          <span className="font-medium">{item.sendCount}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-slate-300">Kanali</span>
          <span className="font-medium">{item.channels.join(", ") || "—"}</span>
        </div>
      </div>
    </Tooltip>
  );
};

export default memo(CalendarEvent);
